export function startParticleSystem({ canvasEl, getColor }) {
  if (!canvasEl) return { burst: () => {}, cleanup: () => {} };

  const ctx = canvasEl.getContext('2d');
  if (!ctx) return { burst: () => {}, cleanup: () => {} };

  let particles = [];
  let rafId = null;

  const resize = () => {
    canvasEl.width = Math.max(1, window.innerWidth);
    canvasEl.height = Math.max(1, window.innerHeight);
  };

  const createParticle = () => {
    const color = typeof getColor === 'function' ? getColor() : '#ffff00';
    return {
      x: Math.random() * canvasEl.width,
      y: Math.random() * canvasEl.height,
      vx: (Math.random() - 0.5) * 2,
      vy: (Math.random() - 0.5) * 2,
      size: Math.random() * 3 + 1,
      opacity: Math.random() * 0.5 + 0.3,
      color
    };
  };

  const animate = () => {
    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);

    for (let i = 0; i < particles.length; i++) {
      const p = particles[i];
      p.x += p.vx;
      p.y += p.vy;

      if (p.x < 0 || p.x > canvasEl.width) p.vx *= -1;
      if (p.y < 0 || p.y > canvasEl.height) p.vy *= -1;

      ctx.fillStyle = p.color;
      ctx.globalAlpha = p.opacity;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.globalAlpha = 1;
    rafId = window.requestAnimationFrame(animate);
  };

  const burst = () => {
    for (let i = 0; i < 50; i++) {
      const color = typeof getColor === 'function' ? getColor() : '#ffff00';
      particles.push({
        x: canvasEl.width / 2,
        y: canvasEl.height / 2,
        vx: (Math.random() - 0.5) * 10,
        vy: (Math.random() - 0.5) * 10,
        size: Math.random() * 5 + 2,
        opacity: 1,
        color
      });
    }

    window.setTimeout(() => {
      particles = particles.slice(0, 100);
    }, 2000);
  };

  resize();
  particles = Array.from({ length: 100 }, createParticle);
  rafId = window.requestAnimationFrame(animate);
  window.addEventListener('resize', resize);

  const cleanup = () => {
    if (rafId) window.cancelAnimationFrame(rafId);
    window.removeEventListener('resize', resize);
    particles = [];
  };

  return { burst, cleanup };
}
